// extracted by mini-css-extract-plugin
export default {"mainTasks":"JPlgv","task":"U5eVQ"};